import React from "react";

import MultibetGenerator from "../../MultibetGenerator";
import SlBet from "../../SlBet";

import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import nth0 from "@/modules/nth0";
import Nnary from "@/modules/Nnary";
import zeroFill from "@/modules/zeroFill";
import nary from "@/modules/nary";

import { IGameTableType } from "@/types/GlobalTypes";
import { rouletteReds } from "@/modules/commonMobile";

interface IProps extends IGameTableType {
    cols: number[];
}

export default class M36 extends React.Component<IProps> {
    render() {
        //Todo: correct winStatement={false}

        const { langdata } = this.props;
        const win = this.props.win ? Number(this.props.win) : null;

        const redClass = "sl-red-lighten";
        const blackClass = "sl-black-lighten";

		const commonBetProps = {
			pcode: this.props.pcode,
			chipBase: this.props.chipBase,
			mobile: this.props.mobile,
			bets: this.props.bets,
			insertBet: this.props.insertBet,
			betOutOfBounds: this.props.betOutOfBounds,
			langStr: langdata.language_code
        };
        
        //Only use this if the SlBet has hover parameters
        const commonHoverProps = {
            hasHover: true,
            mouseOver: mouseOver.bind(this),
            mouseLeave: mouseLeave.bind(this)
        };

        const commonMultiBetProps = {
            ...commonBetProps,
            ...commonHoverProps
        }

        return (
            <div className="sl-table table-m36">
                {
                    [
                        ["Small", "Big"],
                        ["Odd", "Even"], 
                        ["Red", "Black"]
                    ].map(rows =>
                        rows.map(cell =>
                            <SlBet key={"portrait_m36_g_" + cell}

                                classes={"sl-bet col-xs-6 " +
                                    (cell === "Red" ? redClass :
                                     cell === "Black" ? blackClass :
                                     "sl-green-old")
                                }
                                bet={cell}
                                group="n50"

                                winStatement={false}

                                betLabel={("txt_" + cell) in langdata ? langdata["txt_" + cell] : cell}
                                betType="1:0.95"

                                {...commonBetProps}
                                {...commonHoverProps}
                            />
                        )
                    )
                }

                <div className="row sl-green-old">
                {
                    Nnary(0, 2, 1).map(num =>
                        <SlBet key={"m36_g_" + num}

                            classes="sl-bet col-xs-3 sl-green-old"
                            bet={`${nth0(num)} Row`}
                            group="n12"
                        
                            winStatement={false}
                        
                            betLabel={`${langdata["txt_row"]} ${num + 1}`}
                            betType="1:1.9"
                        
                            {...commonBetProps}
                        />
                    )
                }
                </div>

                <div className="row">
                    <div className="col-xs-9">
                    {
                        this.props.cols.map(num =>
                            <div key={"m36_row_g_" + num}>
                            {
                                Nnary(0, 2).map(col => {
                                    const computed = col + num;
                                    const bet = zeroFill(computed, 2);
                
                                    return (
                                        <SlBet key={"m36_g_" + num + "_" + col}

                                            classes={"sl-bet col-xs-4 " + (rouletteReds.indexOf(computed) >= 0 ? redClass : blackClass)}
                                            bet={bet}
                                            group="n"
                                        
                                            winStatement={win ? Number(win) === computed : false}
                                        
                                            betLabel={computed + ""}
                                            betType="1:34"
                                        
                                            {...commonBetProps}
                                        />
                                    );
                                })
                            }
                            </div>
                        )
                    }
                    </div>
                    <div className="col-xs-3">
                    {
                        Nnary(0, 2).map(num =>
                            <SlBet key={"m36_g_" + num + "_12"}

                                classes={"sl-bet sl-green-old taller"}
                                bet={nth0(num) + " 12"}
                                group="n12"
                            
                                winStatement={win ? 
                                    Number(win) >= (num - 1) * 12 &&
                                    Number(win) <= num * 12
                                : false}
                            
                                betLabel={nth0(num) + " 12"}
                                betType="1:1.9"
                            
                                {...commonBetProps}
                            />
                        )
                    }
                    </div>
                </div>

                {
                    /*
                     Pattern:
                     01,04  02,05
                     04,07  05,08
                     */
                }
                <MultibetGenerator
                    keyPattern={
                        Nnary(0, 40, 4).map(row =>
                            Nnary(1, 3).map(cell => {
                                const computed = row + cell;
                                return `${zeroFill(computed, 2)},${zeroFill(computed + 3, 2)}`;
                            })
                        )
                    }
                
                    langdata={langdata}
                
                    firstLeftPercent={12.5}
                    firstTopPercent={31.33}
                
                    leftSpace={"25%"}
                    topSpace={6 + "vh"}
                
                    width={50}
                    height={10}
                
                    betGroup="n2"

                    {... commonMultiBetProps}
                />

                {
                    /*
                     Pattern:
                     01,02  02,03
                     04,05  05,06
                     */
                }
                <MultibetGenerator
                    keyPattern={
                        Nnary(0, 33, 3).map(row =>
                            nary(2).map(cell => {
                                const computed = row + cell;
                                return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)}`;
                            })
                        )
                    }
                
                    langdata={langdata}
                
                    firstLeftPercent={25}
                    firstTopPercent={28}
                
                    leftSpace={"25%"}
                    topSpace={6 + "vh"}
                
                    width={10}
                    height={40}
                
                    betGroup="n2"

                    {... commonMultiBetProps}
                />

                {
                    /*
                     Pattern:
                     01,02,04,05  02,03,05,06
                     04,05,07,08  05,06,08,09
                     */
                }
                <MultibetGenerator
                    keyPattern={
                        Nnary(0, 30, 3).map(row =>
                            nary(2).map(cell => {
                                const computed = row + cell;
                                return `${zeroFill(computed, 2)},${zeroFill(computed + 1, 2)},` +
                                    `${zeroFill(computed + 3, 2)},${zeroFill(computed + 4, 2)}`;
                            })
                        )
                    }
                
                    langdata={langdata}
                
                    firstLeftPercent={25}
                    firstTopPercent={31.33}
                
                    leftSpace={"25%"}
                    topSpace={6 + "vh"}
                
                    width={25}
                    height={25}
                
                    betGroup="n4"

                    {... commonMultiBetProps}
                />
            </div>
        );
    }
}